import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const ProcessStatus = ({ name, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择状态" })}
      clearable
      options={[
        // { id: "success", name: t({ defaultMessage: "成功" }) },
        { id: "resetting", name: t({ defaultMessage: "已处理" }) },
        // { id: "resetting", name: t({ defaultMessage: "已重置" }) },
        { id: "failed", name: t({ defaultMessage: "未处理" }) }
      ]}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export default ProcessStatus;
